<template lang="pug">
    div
        v-card.pa-0
            //h1.title.text-md-center SUBFAMILIAS ASOCIADAS
            v-layout(row wrap)
                v-flex(md12)
                    model-data-table(
                        loading-text="Cargando subfamilias..."
                        no-data-text="Sin subfamilias."
                        no-search
                        ref="table"
                        v-bind="tableProps"
                        @detail="editSubfamily($event.item)"
                        @remove="submitRemove"
                        :no-detail="!$can('VIEW_DETAIL_PRODUCT_SUBFAMILY')"
                        :no-remove="!$can('DELETE_PRODUCT_SUBFAMILY')"
                        )

        v-dialog(v-model="dialog" width='800')
            v-toolbar.primary(dark)
                span.title {{showEdit ? 'Editar' : 'Crear'}} Subfamilia
                v-spacer
                v-switch.ma-0.pt-4(
                  label="editar"
                  style="position: absolute; right: 20px;"
                  v-model="editable"
                  v-if="!!showEdit"
                  )
            v-card.pa-4
              v-form(ref="form")
                v-text-field(
                  label="Nombre"
                  outline
                  v-model="subfamilyName"
                  :disabled="!!showEdit && !editable"
                  @keydown.enter="handleSubfamily"
                  :rules="[v => !!v || 'Campo Obligatorio']"
                  )
                v-btn(
                  block
                  :color="colors.secondary"
                  :disabled="!!showEdit && !editable"
                  @click="handleSubfamily"
                  ) {{showEdit ? 'EDITAR' : 'CREAR'}} Subfamilia
        //v-dialog(v-model='dialog' width='600')
            v-card
                v-toolbar.primary(dark)
                model-form(
                        title="Detalle Subfamilia"
                        :fields="fields"
                        ref="form"
                        :switchEdit="$can('EDIT_PRODUCT_SUBFAMILY')"
                        reset-text="restablecer"
                        submit-text="editar subfamilia"
                        :editable="isEditable"
                        v-model="modelData"
                        @reset="restoreValueSubfamily"
                        @submit="handleSubmit"
                        )
        //v-dialog(v-model="dialogCreateSubfamily" width='600')
            v-card
                v-card-title.headline.grey.lighten-2(primary-title) Crear Subfamilia
            CrudForm(
                v-bind="staticDataSubfamilyCreate"
                :fields="myFieldsSubfamilyCreate"
                :customRules="customRules"
                submitText="crear"
                @submitForm="handleSubmitCreateSubfamily($event)"
                :noButtons="!$can('CREATE_PRODUCT_SUBFAMILY')"
                )
        
</template>

<script>
import {
    ModelDataTable,
    ModelForm,
} from '@/components/reusable_components/next'
import { CrudForm } from '@/components/reusable_components'
import ExampleDTService from '@/services/api/ExampleDTService'
import SubfamilyDTService from '@/services/api/subfamily/SubfamilyDTService'
import { mapActions, mapState } from 'vuex'
import {
    generateFetchDataFunction,
    generateDeleteItemFunction,
} from '@/services/api/DataTableService'
//
import { DELETE_SUBFAMILY } from '@/components/SnackbarModal/SnackbarActions'
import SubfamilyService from '@/services/api/subfamily/SubfamilyService'
//-
import MdlSubfamily from '@/models/Warehouse/WhSubfamily'
import MdlFamily from '@/models/Warehouse/WhFamily'
import HeadersSubfamily from './headers'
import FiltersSubfamily from './filters'
import FieldsSubfamily from './FieldsSubfamily'
import FieldsCreateSubfamily from './FieldsCreateSubfamily'
//
export default {
    name: 'family-list',
    props: {
        familyId: {
            type: String,
            required: true,
        },
    },
    data: function() {
        return {
            // service: {
            //     dtFetchData: {},
            // },
            headers: HeadersSubfamily,
            filters: FiltersSubfamily,
            selected: [],
            subfamilyDeleteId: null,
            dialog: false,
            staticData: null,
            fields: FieldsSubfamily,
            customRules: {
                minLength8: function(value) {
                    return value.length >= 8 ? true : 'El largo mínimo es 8'
                },
            },
            subfamily: {},
            dialogCreateSubfamily: false,
            staticDataSubfamilyCreate: null,
            myFieldsSubfamilyCreate: FieldsCreateSubfamily,
            isEditable: false,
            modelData: {},
            subfamilyName: '',
            editable: false,
            showEdit: null,
        }
    },
    computed: {
        ...mapState('SnackbarModalModule', {
            responseConfirm: 'responseConfirm',
        }),
        tableProps() {
            return {
                service: MdlSubfamily,
                paramFilter: {
                    wh_family_id: this.familyId,
                },
                headers: this.headers,
                filters: this.filters,
            }
        },
    },
    methods: {
        ...mapActions('MenuesModule', {
            setTitleTopBar: 'setTitleTopBar',
        }),
        ...mapActions('SnackbarModalModule', {
            initSnackbar: 'initSnackbar',
            hideSnack: 'hideSnack',
            resetSnackbarState: 'resetSnackbarState',
            setMessageConfirmSnack: 'setMessageConfirmSnack',
        }),
        submitRemove(event) {
            //
            this.resetSnackbarState()
            this.setMessageConfirmSnack(DELETE_SUBFAMILY)

            //
            let payload = this.fillSnack(
                'warning',
                'Advertencia',
                '¿Desea eliminar subfamilia?'
            )
            this.initSnackbar(payload)

            //
            this.subfamilyDeleteId = event.item.id
        },
        /*
         */
        async handleSubmit(event) {
            this.formData = event
            await this.sendUpdateSubfamily(this.formData)
        },
        /*
         */
        async sendUpdateSubfamily(data) {
            let response = await SubfamilyService.updateSubfamily(
                this.subfamily.id,
                data.subfamily
            )
            if (response.status == 'success') {
                //TODO: add snack
                let snackInfo = this.fillSnack(
                    'success',
                    'Éxito',
                    'Subfamilia editada exitosamente',
                    false,
                    3000
                )
                this.initSnackbar(snackInfo)
                // this.$router.push({
                //     path: `/families/${this.$route.params.id}`,
                // })
                this.dialog = false
                this.$refs.table.refresh()
            }
        },
        /*
         */
        editSubfamily(event) {
            console.log(event)
            this.showEdit = event
            this.subfamilyName = event.subfamily
            this.dialog = true
        },
        /*
         */
        restoreValueSubfamily() {
            this.modelData = {}
        },
        /*
         */
        async handleSubmitCreateSubfamily() {
            this.formData = { subfamily: this.subfamilyName }
            let snackInfo = this.fillSnack(
                'info',
                'Creando Subfamilia',
                'La subfamilia esta siendo creada',
                true
            )
            //FIXME: fixed snack bar for allowing to throw different timeouts
            //this.initSnackbar(snackInfo)
            let response = await SubfamilyService.createSubfamily(
                this.$route.params.id,
                this.formData
            )
            if (response.status == 'success') {
                this.resetSnackbarState()
                let snackInfo = this.fillSnack(
                    'success',
                    'Éxito',
                    'La subfamilia fue creada exitosamente',
                    false,
                    3000
                )
                this.initSnackbar(snackInfo)
                this.dialog = false
                this.$refs.table.refresh()
            } else {
                //TODO:add snack
                console.log(event, 'error')
            }
        },
        handleSubfamily(e) {
            e.preventDefault()
            e.stopPropagation()
            if (!this.$refs.form.validate()) return
            if (!this.showEdit)
                this.handleSubmitCreateSubfamily({ family: this.familyName })
            else {
                let f = this.showEdit
                f.subfamily = this.subfamilyName
                f.save()
                    .then(r => {
                        this.$refs.table.refresh()
                        this.showEdit = false
                        this.dialog = false
                        this.$refs.table.refresh()
                        this.resetSnackbarState()
                        let snackInfo = this.fillSnack(
                            'success',
                            'Éxito',
                            'La subfamilia fue creada exitosamente',
                            false,
                            3000
                        )
                        this.initSnackbar(snackInfo)
                    })
                    .catch(console.log)
            }
        },
    },
    watch: {
        async responseConfirm(val) {
            //
            if (val === DELETE_SUBFAMILY) {
                //
                this.resetSnackbarState()

                //
                let response = await SubfamilyService.deleteSubfamily(
                    this.subfamilyDeleteId
                )

                //
                if (response.status == 200) {
                    this.resetSnackbarState()
                    let payload = this.fillSnack(
                        'success',
                        'Subfamilia eliminada.',
                        'La subfamilia fue eliminada exitosamente',
                        false,
                        5000
                    )
                    this.initSnackbar(payload)
                    this.$refs.table.refresh()
                } else {
                    //
                    let payload = this.fillSnack(
                        'error',
                        'Error',
                        response.message + '. ' + response.error
                    )
                    this.initSnackbar(payload)
                }
            }
        },
    },
    components: {
        'model-data-table': ModelDataTable,
        'model-form': ModelForm,
        CrudForm,
    },
    mixins: [],
    filters: {},
    // Lifecycle Methods
    //
    // beforeCreate: function(){...},
    // created: function(){...},
    beforeMount: function() {
        this.$setItemsTopBar([
            /*{
                text: 'descuentos al por mayor',
                icon: 'local_offer',
                color: 'teal',
                can: 'CREATE_WHOLESALE_DISCOUNT_BY_FAMILY',
                action: () =>
                    this.$router.push(
                        `/families/${this.$route.params.id}/wholesale_discounts`
                    ),
            },*/
            {
                text: 'crear subfamilia',
                icon: 'add',
                can: 'CREATE_PRODUCT_SUBFAMILY',
                action: () => (this.dialog = true),
            },
        ])
    },
    mounted: function() {
        MdlFamily.find(this.$route.params.id).then(family => {
            this.setTitle('Subfamilias de ' + family.family)
        })

        // this.staticData = this.fillStaticFormData()
        // this.staticDataSubfamilyCreate = this.fillStaticFormDataSubfamily()
    },
    // beforeUpdate: function(){...},
    // updated: function(){...},
    // beforeDestroy: function(){...},
    // destroyed: function(){...},
    //
    // End Lifecycle Methods
}
</script>

<style lang="scss"></style>
